/*
 * File: /src/services/dialDestenationServices.js
 * Created Date: Sunday May 23rd 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 23rd May 2021 11:03:48 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_DIAL_DESTINATION_PATH } from '../constants';

export default {

  fetchDialDestinations() {
    return authedAxios.get(AD_BASE_DIAL_DESTINATION_PATH);
  },

  /**
   * Destinations for the logged in user only.
   */
  fetchUserDialDestinations() {
    return authedAxios.get(AD_BASE_DIAL_DESTINATION_PATH + 'user');
  },

  /**
   * Destinations for a specific user, used for editing users
   */
  fetchDialDestinationsByUserId(userId) {
    return authedAxios
      .get(AD_BASE_DIAL_DESTINATION_PATH, {
        params: { filter: ['user_id:eq:' + userId] },
      })
      .then((r) => (r.data ?? []).filter((d) => d.user_id == userId));
  },

  fetchDialDestination(id) {
    return authedAxios.get(AD_BASE_DIAL_DESTINATION_PATH + id);
  },

  createDialDestination(payload) {
    return authedAxios.post(AD_BASE_DIAL_DESTINATION_PATH, payload);
  },

  /**
   * Same full body as create, this is a full replace not patch
   */
  updateDialDestination(id, payload) {
    return authedAxios.put(AD_BASE_DIAL_DESTINATION_PATH + id, payload);
  },

  // Soft delete only for now
  deleteDialDestination(id) {
    return authedAxios.delete(AD_BASE_DIAL_DESTINATION_PATH + id);
  },
};
